module.exports = __webpack_public_path__ + "img/pos4-bg.50b061fa.jpg";